<template>
  <div class="the-navbar__user-meta flex items-center" v-if="user && userName">
    <div class="text-right leading-tight hidden sm:block" style="width: max-content;">
      <p class="user-name">{{ userName }}</p>
      <p class="role-name">{{ roleName }}</p>
    </div>
    <div class="vertical-spacer"></div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img">
        <font-awesome-icon size="lg"  :icon="['far', 'user']"/>
      </div>

      <vs-dropdown-menu class="user-dropdown vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            v-if="canImpersonate"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="showImpersonateModal = !showImpersonateModal"
          >
            <feather-icon icon="ShuffleIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Impersonator</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
    <impersonate-modal v-if="canImpersonate" v-model="showImpersonateModal"/>
  </div>
</template>

<script>

import Import from '../../../../views/components/extra-components/import-export/Import';
import ImpersonateModal from '@/layouts/components/navbar/components/ImpersonateModal';
import store from '@/store/store';

export default {
  components: {
    Import,
    ImpersonateModal,
  },
  data () {
    return {
      showImpersonateModal: false,
      canImpersonate: false,
    }
  },
  props: {
    name: {
      type: String,
    },
    role: {
      type: String,
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/user'];
    },
    userName() {
      if (this.name) {
        return this.name;
      }

      return this.user.name;
    },
    roleName() {
      if (this.role) {
        return this.role;
      }

      const role = this.user.company.roles.filter((role) =>
          role.applications[0].ExternalIdentity_Key === process.env.VUE_APP_AUTH0_CLIENT_ID
      );

      return role[0].RoleName;
    },
  },
  async created() {
    await this.chectImpersonatePrivilege();
  },
  methods: {
    async logout () {
      // if user is logged in via auth0
      await this.$store.dispatch('auth/logout');
    },
    async chectImpersonatePrivilege() {
      const privilegesData = store.getters['personas/privileges'];
      const impersonatePrivilege = privilegesData.find((navAccessItem) => navAccessItem.PageName === 'impersonate_company');

      if (!impersonatePrivilege) {
        return false;
      }
      
      this.canImpersonate = impersonatePrivilege.View;

      return this.canImpersonate;
    },
  }
}
</script>

<style lang="scss">
@import '../../../../assets/scss/custom/components/variables';

.user-dropdown {
  margin-left: 13px;
  margin-top: 15px;
}

.the-navbar__user-meta {
  background-color: $grey-darkest;
  border: 1px solid $grey-darkest;
  border-radius: 5px;
  padding: 10px 15px;
  color: #fff;
  //width: 200px;
  height: 50px;

  .role-name {
    color: $yellow;
    font-size: 10px;
  }
}
</style>
